import React, { useState, useEffect } from 'react';
import { getExpressParams } from '../../../service/api';
import { connect } from 'react-redux';
import ExportExcel from '../export-excel/ExportExcel';

const UsageManager = (props) => {
  const [months, setMonths] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);

  useEffect(() => {
    getExpressParams('/users/usage-content/monthcode',{
      email: props.currentUser
    }, (response) => {
      let arr = [];
      response.data.monthcode.forEach(item => {
        arr.push(item.monthcode);
      });
      setMonths(arr);
      setSelectedMonth(Number(arr[0]))
    })
  },[])

  const handleChange = (e) => {
    setSelectedMonth(Number(e.target.value)); // 문자열로 들어오기 때문에 숫자로 변환
  };

  const handleButtonClick = () => {
    getExpressParams('/users/usage-content/exceldata',{
      email: props.currentUser,
      monthcode: selectedMonth
    }, (response) => {
      ExportExcel('usage', response.data.usageentity)
    })
  }

  return (
    <div>
      {months &&
      <>
        <label htmlFor="month-select">Select Month: </label>
        <select id="month-select" value={selectedMonth} onChange={handleChange}>
          {months.map((month) => (
            <option key={month} value={month}>
              {month}
            </option>
          ))}
        </select>
        {/* <p>Selected Month: {selectedMonth}</p> */}
        <p></p>
        <a className="button purple_line"  onClick={()=>handleButtonClick()}>엑셀 다운로드</a>
      </>
      }
    </div>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
})
export default connect(mapStateToProps) (UsageManager);
